import React from "react";

import Element from "../structure/Element";

const Message = ({ children, type, textAlign = "center", ...props }) => (
  <Element
    color="rgba(0,0,0,0.5)"
    backgroundColor={type}
    padding={12}
    borderRadius={4}
    textAlign={textAlign}
    {...props}
  >
    {children}
  </Element>
);

export default Message;
